module.exports = "/_next/static/images/AppStoreButton-6caaccfc7e7c443bab0d447a57863ac5.svg";